import { Box, styled } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber } from 'utils/numbers'

const Container = styled('div')(({ theme }) => ({
  background: '#f4f4f4',
  color: '#474747',
  gap: 10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px',
  fontSize: 10,
}))

export const FooterCell = ({ value = 0 }) => {
  const { t } = useTranslation()

  return (
    <Container>
      <span>{t('creditosDeBiodiversidade.pontuacaoTotal')}</span>
      <Box sx={{ fontSize: 15 }}>{formatNumber(value)}</Box>
    </Container>
  )
}
